import ProfilePage from '@/pages/profile-page.vue';
import DashboardHome from '@/pages/Dashboard.vue';
import ClientAreaPage from '@/pages/ClientAreaPage.vue';
import HomePage from '@/pages/home.vue';
import NotFoundPage from '@/pages/404.vue';
import AgronomySamplesPage from '@/pages/Agronomy/agro-samples-page.vue';
import EnvironmentSamplesPage from '@/pages/Environment/index.vue';
import EnvironmentStatsPage from '@/pages/Environment/stats/index.vue';
import FoodSamplesPage from '@/pages/Food/food-samples-page.vue';
import MiningSamplesPage from '@/pages/Mining/index.vue';
import HealthAndSecuritySamplesPage from '@/pages/HealthAndSecurity/index.vue';
import UsersManagementPage from '@/pages/Users/users-management-page.vue';
import UsersManagementFullPage from '@/pages/Users/users-management-full-page.vue';
import UsersCreatePage from '@/pages/Users/users-create-page.vue';
import UsersEditPage from '@/pages/Users/users-edit-page.vue';
import RiskAnalysisPage from '@/pages/Food/RiskAnalysis/index.vue';
import FoodStatsPage from '@/pages/Food/Stats/index.vue';
import NutritionalMonitoringPage from '@/pages/Agronomy/NutritionalMonitoring/index.vue';
import AdvancedServicesPage from '@/pages/Agronomy/AdvancedServices/index.vue';
import DashboardPage from '@/pages/Agronomy/AdvancedServices/Dashboard/index.vue';
import NutritionalMonitoring from '@/pages/Agronomy/AdvancedServices/NutritionalMonitoring/index.vue';
import AdvancedServicesManagementPage from '@/pages/Agronomy/AdvancedServices/Management/index.vue';
import AdvancedServicesParcelRegistrationPage from '@/pages/Agronomy/AdvancedServices/Management/RegisterParcel/index.vue';
import AdvancedServicesStationRegistrationPage from '@/pages/Agronomy/AdvancedServices/Management/RegisterStation/index.vue';
import TokenRecoveryPage from '@/pages/Users/TokenRecoveryPage/index.vue';
import WeatherGraphsPage from '@/pages/WeatherGraphs/index.vue';
import TimeDimensionMapPage from '@/pages/Agronomy/AdvancedServices/Dashboard/TimeDimensionMap/index.vue';
import GisComparatorPage from '@/pages/Agronomy/AdvancedServices/Dashboard/GisComparator/index.vue';
import TimeDimensionComparatorPage from '@/pages/Agronomy/AdvancedServices/Dashboard/TimeDimensionComparator/index.vue';
import MIRDetail from '@/pages/Agronomy/AdvancedServices/MIRDetail/index.vue';
import MIRStationsPage from '@/pages/Agronomy/AdvancedServices/MIRStations/index.vue';
import GisActionsPage from '@/pages/Agronomy/AdvancedServices/GisActions/index.vue';
import NewContactPage from '@/pages/Users/Contacts/NewContactPage.vue';

// Documentation
import FoodDocumentationPage from '@/pages/Food/Documentation/index.vue';
import AgronomyDocumentationPage from '@/pages/Agronomy/Documentation/index.vue';
import EnvironmentDocumentationPage from '@/pages/Environment/Documentation/index.vue';
import MiningDocumentationPage from '@/pages/Mining/Documentation/index.vue';
import HealthSecurityDocumentationPage from '@/pages/HealthAndSecurity/Documentation/index.vue';

// Details pages
import AgroDetailsPage from '@/pages/Agronomy/AgronomyDetails/agro-details-page.vue';
import FoodSampleDetailPage from '@/pages/Food/FoodSampleDetailPage/index.vue';
import EnvironmentSamplesDetailsPage from '@/pages/Environment/SamplesDetailsPage/index.vue';
import MiningSamplesDetailsPage from '@/pages/Mining/SamplesDetailsPage/index.vue';
import HealthSecuritySamplesDetailsPage from '@/pages/HealthAndSecurity/SamplesDetailsPage/index.vue';

// Alerts
import AlertsParamsPage from '@/pages/Alerts/Settings/params/index.vue';
import AlertsSamplePage from '@/pages/Alerts/Settings/sample/index.vue';
import AlertsParamsReportsPage from '@/pages/Alerts/Reports/params/index.vue';
import AlertsSampleReportsPage from '@/pages/Alerts/Reports/sample/index.vue';
import AlertsReportsParamsDetailsPage from '@/pages/Alerts/Reports/params/details.vue';
import AlertsSampleReportsDetailsPage from '@/pages/Alerts/Reports/sample/details.vue';

// StatsQueries
import PesticideResidues from '@/pages/StatsQueries/ResiduosPlaguicidas/index.vue';
import Nutrivisor from '@/pages/StatsQueries/NutriVisor/index.vue';
// Notifications
import NotificationsDetailsPage from '@/pages/Notifications/index.vue';

// Privacy Policy
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage.vue';
import LegalDocumentsPage from '@/pages/LegalDocumentsPage.vue';
import LegalDocumentsInternalPage from '@/pages/LegalDocumentsInternalPage.vue';

// OffersList
import OffersList from '@/pages/OffersList/index.vue';
import OffersDetails from '@/pages/OffersList/OffersDetails/offers-details-page.vue';
import OffersDetailsAnalytics from '@/pages/OffersList/OffersDetails/Offers-details-analytics.vue';

// Material Request
import MaterialRequest from '@/pages/MaterialRequest/index.vue';
import MaterialRequester from '@/pages/MaterialRequest/MaterialRequester/MaterialRequester.vue';

// My Issued Invoices
import IssuedInvoicesList from '@/pages/IssuedInvoicesList/index.vue';
import IssuedInvoicesDetails from '@/pages/IssuedInvoicesList/IssuedInvoicesDetails/issued-invoices-details-page.vue';

// Catalogo de servicios
import ServiceCatalog from '@/pages/ServiceCatalog/index.vue';
import ServiceCatalogDetails from '@/pages/ServiceCatalog/ServiceCatalogDetails/ServiceCatalogDetails.vue';

// Templates Manager
import TemplatesListPage from '@/pages/TemplatesManager/TemplatesListPage.vue';
import TemplateDetailsPage from '@/pages/TemplatesManager/TemplateDetailsPage.vue';
import TemplateCreatePage from '@/pages/TemplatesManager/TemplateCreatePage.vue';

// Samples Register
import SamplesRegister from '@/pages/SamplesRegister/SamplesRegister.vue';
import SamplesConfirmation from '@/pages/SamplesRegister/SamplesConfirmation/index.vue';
import SamplesList from '@/pages/SamplesRegister/InvoiceList/index.vue';
import SamplesDetails from '@/pages/SamplesRegister/SamplesRegisteredDetails/index.vue';
import InvoiceSamplesListDetails from '@/pages/SamplesRegister/InvoiceSamplesListDetails/index.vue';
import InvoiceDeliveryHeaderEdit from '@/pages/SamplesRegister/InvoiceDeliveryHeaderEdit/index.vue';

// Complaint Management
import ComplaintManagement from '@/pages/ComplaintManagement/index.vue';
import ComplaintManagementDetails from '@/pages/ComplaintManagement/ComplaintDetails/complaint-details-page.vue';
import ComplaintRegister from '@/pages/ComplaintManagement/ComplaintRegister/complaint-register-page.vue';

const routes = [
  {
    path: '/',
    name: 'DashboardHome',
    component: DashboardHome,
  },
  {
    path: '/SampleSummary',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/food/StatsQueries/',
    name: 'PesticideResidues',
    component: PesticideResidues,
  },
  {
    path: '/agronomy/NutriVisor',
    name: 'Nutrivisor',
    component: Nutrivisor,
  },
  {
    path: '/OffersList/',
    name: 'offersList',
    component: OffersList,
  },
  {
    path: '/OffersDetails/',
    name: 'offersDetails',
    component: OffersDetails,
  },
  {
    path: '/ServiceCatalog/',
    name: 'serviceCatalog',
    component: ServiceCatalog,
  },
  {
    path: '/ServiceCatalogDetails/',
    name: 'serviceCatalogDetails',
    component: ServiceCatalogDetails,
  },
  {
    path: '/TemplatesManager/TemplatesList/',
    name: 'TemplatesListPage',
    component: TemplatesListPage,
  },
  {
    path: '/TemplatesManager/TemplatesList/Details/',
    name: 'TemplateDetailsPage',
    component: TemplateDetailsPage,
  },
  {
    path: '/TemplatesManager/TemplatesList/Create/',
    name: 'TemplateCreatePage',
    component: TemplateCreatePage,
  },
  {
    path: '/MaterialRequest/',
    name: 'MaterialRequest',
    component: MaterialRequest,
  },
  {
    path: '/MaterialRequester/',
    name: 'MaterialRequester',
    component: MaterialRequester,
  },
  {
    path: '/OffersDetailsAnalytics/',
    name: 'OffersDetailsAnalytics',
    component: OffersDetailsAnalytics,
  },
  {
    path: '/issued-invoices-list/',
    name: 'issuedInvoicesList',
    component: IssuedInvoicesList,
  },
  {
    path: '/issued-invoices-details/',
    name: 'issuedInvoicesDetails',
    component: IssuedInvoicesDetails,
  },
  {
    path: '/SamplesList',
    name: 'SamplesList',
    component: SamplesList,
  },
  {
    path: '/SamplesRegister',
    name: 'SamplesRegister',
    component: SamplesRegister,
  },
  {
    path: '/SamplesRegister/SamplesConfirmation',
    name: 'SamplesConfirmation',
    component: SamplesConfirmation,
  },
  {
    path: '/SamplesRegister/SamplesDetails',
    name: 'SamplesDetails',
    component: SamplesDetails,
  },
  {
    path: '/InvoiceSamplesListDetails',
    name: 'InvoiceSamplesListDetails',
    component: InvoiceSamplesListDetails,
  },
  {
    path: '/InvoiceDeliveryHeaderEdit',
    name: 'InvoiceDeliveryHeaderEdit',
    component: InvoiceDeliveryHeaderEdit,
  },
  {
    path: '/ComplaintManagement/',
    name: 'ComplaintManagement',
    component: ComplaintManagement,
  },
  {
    path: '/complaintManagementDetails',
    name: 'ComplaintManagementDetails',
    component: ComplaintManagementDetails,
  },
  {
    path: '/complaintRegister',
    name: 'ComplaintRegister',
    component: ComplaintRegister,
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyPage,
  },
  {
    path: '/legal-documents',
    name: 'LegalDocuments',
    component: LegalDocumentsPage,
  },
  {
    path: '/legal-notice',
    name: 'LegalNotice',
    component: LegalDocumentsPage,
  },
  {
    path: '/legal-documents-internal',
    name: 'LegalDocumentsInternal',
    component: LegalDocumentsInternalPage,
  },
  {
    path: '/legal-notice-internal',
    name: 'LegalNoticeInternal',
    component: LegalDocumentsInternalPage,
  },
  {
    path: '/users',
    name: 'UsersManagementPage',
    component: UsersManagementPage,
  },
  {
    path: '/users/create',
    component: UsersCreatePage,
  },
  {
    path: '/users/edit',
    name: 'UsersEditPage',
    component: UsersEditPage,
  },
  {
    path: '/profile',
    name: 'ProfilePage',
    component: ProfilePage,
  },
  {
    path: '/contacts/new',
    name: 'NewContactPage',
    component: NewContactPage,
  },
  {
    path: '/client-area',
    name: 'ClientAreaPage',
    component: ClientAreaPage,
  },
  {
    path: '/client-area/contact-management',
    name: 'UsersManagementFullPage',
    component: UsersManagementFullPage,
  },
  {
    path: '/agronomy/samples',
    name: 'AgronomySamplesPage',
    component: AgronomySamplesPage,
  },
  {
    path: '/agronomy/nutritionalMonitoring',
    name: 'NutritionalMonitoringMainPage',
    component: NutritionalMonitoringPage,
  },
  {
    path: '/agronomy/nutritionalMonitoring/nutritional-monitoring',
    name: 'NutritionalMonitoringPage',
    component: NutritionalMonitoring,
  },
  {
    path: '/agronomy/advanced-services',
    name: 'AdvancedServicesPage',
    component: AdvancedServicesPage,
  },
  {
    path: '/agronomy/advanced-services/dashboard',
    name: 'DashboardPage',
    component: DashboardPage,
  },
  {
    path: '/agronomy/advanced-services/management',
    name: 'AdvancedServicesManagementPage',
    component: AdvancedServicesManagementPage,
  },
  {
    path: '/agronomy/advanced-services/management/parcel-registration',
    name: 'AdvancedServicesParcelRegistrationPage',
    component: AdvancedServicesParcelRegistrationPage,
  },
  {
    path: '/agronomy/advanced-services/management/station-registration',
    name: 'AdvancedServicesStationRegistrationPage',
    component: AdvancedServicesStationRegistrationPage,
  },
  {
    path: '/agronomy/advanced-services/gis-actions',
    name: 'GisActionsPage',
    component: GisActionsPage,
  },
  {
    path: '/agronomy/samples/details',
    name: 'AgronomySamplesDetailsPage',
    component: AgroDetailsPage,
  },
  {
    path: '/agronomy/documentation',
    name: 'AgronomyDocumentationPage',
    component: AgronomyDocumentationPage,
  },
  {
    path: '/environment/samples',
    name: 'EnvironmentSamplesPage',
    component: EnvironmentSamplesPage,
  },
  {
    path: '/environment/samples/details',
    name: 'EnvironmentSamplesDetailsPage',
    component: EnvironmentSamplesDetailsPage,
  },
  {
    path: '/environment/documentation',
    name: 'EnvironmentDocumentationPage',
    component: EnvironmentDocumentationPage,
  },
  {
    path: '/environment/stats',
    name: 'EnvironmentStatsPage',
    component: EnvironmentStatsPage,
  },
  {
    path: '/food/risk-analysis',
    name: 'RiskAnalysisPage',
    component: RiskAnalysisPage,
  },
  {
    path: '/food/stats',
    name: 'FoodStatsPage',
    component: FoodStatsPage,
  },
  {
    path: '/food/samples',
    name: 'FoodSamplesPage',
    component: FoodSamplesPage,
  },
  {
    path: '/food/samples/details',
    name: 'FoodSampleDetailPage',
    component: FoodSampleDetailPage,
  },
  {
    path: '/food/documentation',
    name: 'FoodDocumentationPage',
    component: FoodDocumentationPage,
  },
  {
    path: '/mining/samples',
    name: 'MiningSamplesPage',
    component: MiningSamplesPage,
  },
  {
    path: '/mining/samples/details',
    name: 'MiningSamplesDetailsPage',
    component: MiningSamplesDetailsPage,
  },
  {
    path: '/mining/documentation',
    name: 'MiningDocumentationPage',
    component: MiningDocumentationPage,
  },
  {
    path: '/health-and-security/samples',
    name: 'HealthAndSecuritySamplesPage',
    component: HealthAndSecuritySamplesPage,
  },
  {
    path: '/health-and-security/samples/details',
    name: 'HealthSecuritySamplesDetailsPage',
    component: HealthSecuritySamplesDetailsPage,
  },
  {
    path: '/health-and-security/documentation',
    name: 'HealthSecurityDocumentationPage',
    component: HealthSecurityDocumentationPage,
  },
  {
    path: '/alerts/params',
    name: 'AlertsParamsPage',
    component: AlertsParamsPage,
  },
  {
    path: '/alerts/params/reports',
    name: 'AlertsParamsReportsPage',
    component: AlertsParamsReportsPage,
  },
  {
    path: '/alerts/params/reports/details',
    name: 'AlertsReportsParamsDetailsPage',
    component: AlertsReportsParamsDetailsPage,
  },
  {
    path: '/alerts/sample',
    name: 'AlertsSamplePage',
    component: AlertsSamplePage,
  },
  {
    path: '/alerts/sample/reports',
    name: 'AlertsSampleReportsPage',
    component: AlertsSampleReportsPage,
  },
  {
    path: '/alerts/sample/reports/details',
    name: 'AlertsSampleReportsDetailsPage',
    component: AlertsSampleReportsDetailsPage,
  },
  {
    path: '/notifications',
    name: 'NotificationsDetailsPage',
    component: NotificationsDetailsPage,
  },
  {
    path: '/token-recovery',
    name: 'TokenRecoveryPage',
    component: TokenRecoveryPage,
  },
  {
    path: '/agronomy/advanced-services/weather-graphs',
    name: 'WeatherGraphsPage',
    component: WeatherGraphsPage,
  },
  {
    path: '/agronomy/advanced-services/gis/parcel-detail',
    name: 'TimeDimensionMapPage',
    component: TimeDimensionMapPage,
  },
  {
    path: '/agronomy/advanced-services/gis/comparator',
    name: 'GisComparatorPage',
    component: GisComparatorPage,
  },
  {
    path: '/agronomy/advanced-services/gis/parcel-detail-comparator',
    name: 'TimeDimensionComparatorPage',
    component: TimeDimensionComparatorPage,
  },
  {
    path: '/agronomy/advanced-services/mir-detail',
    name: 'MIRDetail',
    component: MIRDetail,
  },
  {
    path: '/agronomy/advanced-services/mir-stations',
    name: 'MIRStationsPage',
    component: MIRStationsPage,
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
